import { Col, Divider, Image, Row } from 'antd';
import CommonFormAnt from 'commons/Forms/CommonFormAnt';
import {
    commonElement,
    commonInput,
    commonInputRows
} from 'commons/Forms/formsComponents/formTypes';
import { openNotification } from 'commons/Notifications';
import logoImg from 'images/logo.png';
import { Link } from 'react-router-dom';
import ServiceAuth from 'services/auth';


const formFields: Array<commonInput | commonInputRows | commonElement> = [
    {
        type: 'string', // "email",
        name: 'email',
        label: 'Email',
        placeholder: 'Email',
    },
];

const ResetPasswordForm = (props) => {
    //const { authenticate } = useContext(AuthContext);

    const doResetPassword = async (data) => {
        ServiceAuth.resetPassword(data).then((res) => {
            openNotification({
                message: 'OK',
                description: 'Email inviata correttamente, controllare la casella di posta per i dettagli',
                type: 'success',
            });
        });
    };

    return (
        <Row justify="space-around" align="middle">
            <Col span={8} style={{ margin: '6% auto', textAlign: 'center' }}>
                <Image src={logoImg} />
                <section className="appLogin">
                    <h1><strong>RECUPERA PASSWORD</strong></h1>
                    <h3 dangerouslySetInnerHTML={{
                        __html: "Inserire la mail per procedere con il recupero della password"
                    }} />
                    <Divider />
                    <CommonFormAnt
                        autocomplete={true}
                        fields={formFields}
                        onSubmit={(data) => doResetPassword(data)}
                        submitText="Invia"
                        submitOnEnterKey
                    />
                </section>
                <p className="additional-info">
                    Torna alla <Link to="/">Login</Link>
                </p>
            </Col>
        </Row>

    );
};

export default ResetPasswordForm;
